import {Component, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FinalClientService } from '../services/final-client.service';
import Swal from 'sweetalert2';
import {NgbTabset} from '@ng-bootstrap/ng-bootstrap';
import { WizardService } from '../../../shared/service/wizard.service';
import { PlaceFilterForm } from '../../operator/models/PlaceFilterForm';
import { Page } from 'src/app/shared/model/page';
import { Place } from '../models/Place';
import { NetworkContractFilterForm } from '../../operator/models/NetworkContractFilterForm';
import { RequestFilterForm } from '../../operator/models/RequestFilterForm';
import * as moment from 'moment';
import {
  ModalContractCancelComponent
} from '../../../shared/components/modal-contract-cancel/modal-contract-cancel.component';
import {Observable, throwError} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';

@Component({
  selector: 'app-personal-electricity-consumption-place',
  templateUrl: './final-client-electricity.component.html',
  styleUrls: ['./final-client-electricity.component.scss']
})
export class FinalClientElectricityComponent implements OnInit {

  public podValue: string = '';
  public electricityConsumptionPlaces: Page<Place>;
  public electricityContracts: Page<any>;
  public electricityRequests: Page<any>;
  public placeFilterForm: PlaceFilterForm = new PlaceFilterForm();
  public electricityContractFilterForm: NetworkContractFilterForm = new NetworkContractFilterForm();
  public electricityRequestFilterForm: RequestFilterForm = new RequestFilterForm();
  public paginationElectricityConsumptionPlaces = [];
  public paginationElectricityContracts = [];
  public paginationElectricityRequests = [];
  private consumptionPlaceError = 'Va rugam sa va asigurati ca ati introdus POD/CLC corect. Daca este corect introdus, este posibil ca locul de consum pe care incercati sa il asociati sa nu fie inca introdus in platforma de catre Operatorul de retea. Va rugam sa sesizati aceasta situatie catre Furnizorul cu care aveti contract de furnizare.';

  @ViewChild(NgbTabset, { static: false }) tabset: NgbTabset;
  @ViewChild('container', { read: ViewContainerRef }) container: ViewContainerRef;

  constructor(
    private finalClientService: FinalClientService,
    private wizardService: WizardService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    this.searchPlaces();
    this.searchContracts();
    this.searchRequests();
  }

  searchRequests(): void {
    this.finalClientService.getFCElectricityRequests(this.electricityRequestFilterForm).subscribe((val) => {
      this.electricityRequests = val;
      this.electricityRequestFilterForm.pageOffset = val.number;
      this.paginationElectricityRequests = [{ pageNumber: 0, className: 'page-item' }];
      for (let i = 1; i < val.totalPages; i++) {
        this.paginationElectricityRequests.push({ pageNumber: i, className: 'page-item' });
      }
      this.paginationElectricityRequests[this.electricityRequestFilterForm.pageOffset].className = 'page-item active';
    });
  }

  changeRequestPage(page: any): void {
    this.electricityRequestFilterForm.pageOffset = page.pageNumber;
    this.searchRequests();
  }

  previousRequestPage(): void {
    this.electricityRequestFilterForm.pageOffset = this.electricityRequestFilterForm.pageOffset === 0 ? 0 : this.electricityRequestFilterForm.pageOffset - 1;
    this.searchRequests();
  }

  nextRequestPage(): void {
    this.electricityRequestFilterForm.pageOffset = this.electricityRequestFilterForm.pageOffset === this.electricityRequests.totalPages - 1
      ? this.electricityRequestFilterForm.pageOffset : this.electricityRequestFilterForm.pageOffset + 1;
    this.searchRequests();
  }

  searchContracts(): void {
    this.finalClientService.getFCElectricityContracts(this.electricityContractFilterForm).subscribe((val) => {
      this.electricityContracts = val;
      this.electricityContractFilterForm.pageOffset = val.number;
      this.paginationElectricityContracts = [{ pageNumber: 0, className: 'page-item' }];
      for (let i = 1; i < val.totalPages; i++) {
        this.paginationElectricityContracts.push({ pageNumber: i, className: 'page-item' });
      }
      this.paginationElectricityContracts[this.electricityContractFilterForm.pageOffset].className = 'page-item active';
    });
  }

  searchActiveContractsByPlaceId(placeId): Observable<Page<any>> {
    const filterForm = new NetworkContractFilterForm();
    filterForm.placeId = placeId;
    filterForm.active = true;
    return this.finalClientService.getFCElectricityContracts(filterForm);
  }

  searchActiveRequestsByPlaceId(placeId): Observable<Page<any>> {
    const filterForm = new RequestFilterForm();
    filterForm.placeId = placeId;
    filterForm.active = true;
    return this.finalClientService.getFCElectricityRequests(filterForm);
  }

  changeContractPage(page: any): void {
    this.electricityContractFilterForm.pageOffset = page.pageNumber;
    this.searchContracts();
  }

  previousContractPage(): void {
    this.electricityContractFilterForm.pageOffset = this.electricityContractFilterForm.pageOffset === 0 ? 0 : this.electricityContractFilterForm.pageOffset - 1;
    this.searchContracts();
  }

  nextContractPage(): void {
    this.electricityContractFilterForm.pageOffset = this.electricityContractFilterForm.pageOffset === this.electricityContracts.totalPages - 1
      ? this.electricityContractFilterForm.pageOffset : this.electricityContractFilterForm.pageOffset + 1;
    this.searchContracts();
  }

  associateConsumptionPlace(): void {
    if (this.podValue !== '' && this.podValue !== null) {
      this.finalClientService.associateFCElectricityConsumptionPlace(this.podValue).subscribe((val) => {
        this.searchContracts();
        this.searchPlaces();
        this.successAssociationNotification();
      }, error => {
        if (error) {
          this.errorNotification(error.error.message);
        }
      });
    } else {
      this.errorNotification(this.consumptionPlaceError);
    }
  }

  onCustomActionContracts(event: any): void {
    switch (event.action) {
      case 'supplierChange':
        // this.errorNotification('Momentan indisponibil.');
        this.searchActiveRequestsByPlaceId(event.data.placeId).pipe(
          tap((val: Page<any>) => {
            if (val.totalElements > 0) {
              this.errorNotification('Atenție! Pe acest loc de consum există o cerere de contractare / schimbare furnizor în curs de soluționare. Veți putea genera o nouă cerere după finalizarea cererii inițiale.');
            } else {
              this.wizardService.setWizardInformation({
                comparatorType: 'electric',
                editable: 'true',
                previousContractId: String(event.data.id),
                previousContractNumber: String(event.data.number),
                clientTypePF: 'true',
                placeId: String(event.data.placeId),
                supplierId: String(event.data.supplierId),
                supplierLicence: String(event.data.supplierLicence)
              });
              this.router.navigate(
                ['/utilizator/comparator'],
                {
                  queryParams: {
                    comparatorType: 'electric',
                    editable: 'true',
                    contractNumber: String(event.data.number),
                    clientTypePF: 'true',
                    placeId: String(event.data.placeId),
                    supplierId: String(event.data.supplierId)
                  }
                }
              );
            }
          }),
            catchError((error) => {
              this.errorNotification('Nu s-a putut verifica existenta cererilor active pe locul de consum selectat.');
              return throwError(error);
            })
          ).subscribe();
        break;
      case 'additionalAct':
        break;
      case 'recall':
      case 'cancel':
        // this.errorNotification('Momentan indisponibil.');
        Swal.fire({
          html: '<span>Încetarea contractului de furnizare pentru alte motive decât schimbarea furnizorului se realizează prin intermediul furnizorului dumneavoastră. Contactați furnizorul în afara POSF pentru asistență în privința încetării contractului de furnizare.</span><br><span>*În situația în care aveți încheiat un contract de distribuție direct cu operatorul de distribuție este necesar să contactați direct operatorul de distribuție pentru încetarea lui.</span>',
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Anuleaza',
          customClass: {
            popup: 'popup-z-elevate-24-blue'
          }
        });

        /*
        this.searchActiveContractsByPlaceId(event.data.placeId).pipe(
          tap((val: Page<any>) => {
            if (val.totalElements < 2) {
              Swal.fire({
                html: 'Atenție! Această operațiune va trece locul dumneavoastră de consum la furnizorul de ultimă instanță. Doriți să continuați?\n' +
                  '*Dacă nu mai doriți alimentarea locului de consum luați legătura cu furnizorul dumneavoastră pentru a vă înregistra această opțiune.',
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Anuleaza',
                customClass: {
                  popup: 'popup-z-elevate-24-blue'
                }
              }).then(result => {
                if (result.value) {
                  this.openCancelModal();
                  this.finalClientService.cancelContract(event.data.id).subscribe().add(async () => {
                    this.searchContracts();
                    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
                    await sleep(5000);
                    Swal.close();
                  });
                }
              });
            } else {
              Swal.fire({
                html: 'Esti sigur ca vrei sa renunti la acest contract?',
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Anuleaza',
                customClass: {
                  popup: 'popup-z-elevate-24-blue'
                }
              }).then(result => {
                if (result.value) {
                  this.openCancelModal();
                  this.finalClientService.cancelContract(event.data.id).subscribe().add(async () => {
                    this.searchContracts();
                    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
                    await sleep(5000);
                    Swal.close();
                  });
                }
              });
            }
          }),
          catchError((error) => {
            this.errorNotification('Nu s-a putut verifica existenta contractelor active pe locul de consum selectat.');
            return throwError(error);
          })
        ).subscribe();
        */
        break;
      case 'sendIndex':
        this.router.navigate(['index'], {
          relativeTo: this.route, queryParams: {
            contractId: String(event.data.id),
            contractNumber: String(event.data.number),
            placeCode: String(event.data.placeCode),
          }
        });
        break;
      case 'view':
        this.wizardService.setWizardInformation({
          comparatorType: 'electric',
          editable: 'false',
          contractNumber: String(event.data.number),
          clientTypePF: 'true',
          placeId: String(event.data.placeId),
          supplierId: String(event.data.supplierId),
          brokerDocuments: JSON.stringify(event.data.brokerDocuments),
          externalBrokerDocuments: JSON.stringify(event.data.externalBrokerDocuments),
          wizard: JSON.stringify(event.data.wizard)
        });
        this.router.navigateByUrl('/utilizator/schimba-furnizor');
        break;
    }
  }

  onCustomActionConsumptionPlace(event: any): void {
    switch (event.action) {
      case 'newContract':
        // this.errorNotification('Momentan indisponibil.');

        this.searchActiveRequestsByPlaceId(event.data.id).pipe(
          tap((val: Page<any>) => {
            if (val.totalElements > 0) {
              this.errorNotificationHtml('Atenție! Pe acest loc de consum există o cerere de contractare / schimbare furnizor în curs de soluționare. Veți putea genera o nouă cerere după finalizarea cererii inițiale.');
            } else {
              this.searchActiveContractsByPlaceId(event.data.id).pipe(
                tap((val: Page<any>) => {
                  if (val.totalElements > 0) {
                    this.errorNotificationHtml('Atenție! Pe acest loc de consum există contract de furnizare activ.\n' +
                      'Dacă doriți să realizați schimbarea furnizorului, accesați tab-ul Contracte, identificați contractul pe care doriți să-l schimbați și selectați din dreptul acestuia opțiunea “Schimbă furnizor”.');
                  } else {
                    this.wizardService.setWizardInformation({
                      comparatorType: 'electric',
                      clientTypePF: 'true',
                      editable: 'true',
                      placeId: String(event.data.id)
                    });
                    this.router.navigate(
                      ['/utilizator/comparator'],
                      {
                        queryParams: {
                          comparatorType: 'electric',
                          clientTypePF: 'true',
                          editable: 'true',
                          placeId: String(event.data.id)
                        }
                      }
                    );
                  }
                }),
                catchError((error) => {
                  this.errorNotification('Nu s-a putut verifica existenta contractelor active pe locul de consum selectat.');
                  return throwError(error);
                })
              ).subscribe();
            }
          }),
          catchError((error) => {
            this.errorNotification('Nu s-a putut verifica existenta cererilor active pe locul de consum selectat.');
            return throwError(error);
          })
        ).subscribe();

        break;
      case 'consumptionPlaceDetails':
        this.router.navigate(['loc-consum'], { relativeTo: this.route, state: { placeId: event.data.id, editable: false } });
        break;
      case 'viewExistingContracts':
        this.electricityContractFilterForm.placeId = event.data.id;
        this.searchContracts();
        this.tabset.select('contracts');
        break;
      case 'disassociateConsumptionPlace':
        this.finalClientService.disassociateFCConsumptionPlace(event.data.code).subscribe((val) => {
          this.searchPlaces();
          this.searchContracts();
          this.searchRequests();
          this.successDisassociationNotification();
        }, error => {
          if (error) {
            this.errorNotification(error.error.message);
          }
        });
        break;
    }
  }

  searchPlaces(): void {
    this.finalClientService.getFCElectricityConsumptionPlaces(this.placeFilterForm).subscribe((val) => {
      this.electricityConsumptionPlaces = val;
      this.placeFilterForm.pageOffset = val.number;
      this.paginationElectricityConsumptionPlaces = [{ pageNumber: 0, className: 'page-item' }];
      for (let i = 1; i < val.totalPages; i++) {
        this.paginationElectricityConsumptionPlaces.push({ pageNumber: i, className: 'page-item' });
      }
      this.paginationElectricityConsumptionPlaces[this.placeFilterForm.pageOffset].className = 'page-item active';
    });
  }

  changePage(page: any): void {
    this.placeFilterForm.pageOffset = page.pageNumber;
    this.searchPlaces();
  }

  previousPage(): void {
    this.placeFilterForm.pageOffset = this.placeFilterForm.pageOffset === 0 ? 0 : this.placeFilterForm.pageOffset - 1;
    this.searchPlaces();
  }

  nextPage(): void {
    this.placeFilterForm.pageOffset = this.placeFilterForm.pageOffset === this.electricityConsumptionPlaces.totalPages - 1
      ? this.placeFilterForm.pageOffset : this.placeFilterForm.pageOffset + 1;
    this.searchPlaces();
  }

  onCustomActionRequests(event: any): void {
    switch (event.action) {
      case 'view':
        this.wizardService.setWizardInformation({
          comparatorType: 'electric',
          clientTypePF: 'true',
          editable: 'false',
          requestObservations: String(event.data.requestReason),
          wizard: JSON.stringify(event.data.wizard),
          brokerDocuments: JSON.stringify(event.data.brokerDocuments),
          externalBrokerDocuments: JSON.stringify(event.data.externalBrokerDocuments)
        });
        this.router.navigateByUrl('/utilizator/schimba-furnizor');
        break;
      case 'cancel':
        // this.errorNotification('Momentan indisponibil.');
        Swal.fire({
          html: 'Esti sigur ca vrei sa renunti la aceasta cerere?',
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Anuleaza',
           customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
        }).then(result => {
          if (result.value) {
            this.openCancelModal();
            this.finalClientService.cancelRequest(event.data.id).subscribe().add(async () => {
              this.searchRequests();
              const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
              await sleep(5000);
              Swal.close();
            });
          }
        });
        break;
      case 'complete':
        this.wizardService.setWizardInformation({
          comparatorType: 'electric',
          clientTypePF: 'true',
          editable: 'true',
          requestId: String(event.data.id),
          requestObservations: String(event.data.requestReason),
          wizard: JSON.stringify(event.data.wizard)
        });
        this.router.navigateByUrl('/utilizator/schimba-furnizor');
        break;
    }
  }

  public contractSettings = {
    actions: {
      custom: [
        {
          name: 'supplierChange',
          title: '<p class="actionSF" >Schimba furnizor</p>'
        },
        {
          name: 'sendIndex',
          title: '<p class="actionTI">Trimitere index</p>'
        },
        {
          name: 'view',
          title: '<p class="actionVD">Vezi detalii</p>'
        },
        {
          name: 'recall',
          title: '<p class="actionR">Renunta</p>'
        },
        {
          name: 'cancel',
          title: '<p class="actionS">Anuleaza</p>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    rowClassFunction: (row) => {
      let _class = '';
      if (!row.data.wizard) {
        _class += 'row_no_wizard ';
      }
      if (row.data.status == 'ACTIV') {
        const today = moment().startOf('day');
        const startingDate = row.data.startingDate && moment(row.data.startingDate);
        const indexDate = row.data.indexDate ? moment(row.data.indexDate) : moment.unix(0);
        if (
          startingDate && today.diff(startingDate, 'days') === 0 &&
          indexDate && indexDate.diff(startingDate, 'days') < 0
        ) {
          _class += 'row_c_activTI ';
        } else {
          _class += 'row_c_activ ';
        }
        if (row.data.placeStatus === 'DEZAFECTAT') {
          _class += 'row_dezafectat ';
        }
      } else if (row.data.status == 'INCETAT') {
        _class += 'row_c_incetat';
      } else if (row.data.status == 'SUSPENDAT') {
        _class += 'row_c_suspendat';
      } else if (row.data.status == 'ACTIV (in curs de schimbare)') {
        _class += 'row_c_activS';
      } else if (row.data.status == 'ACTIV (neintrat in vigoare)') {
        _class += 'row_c_activNV';
      } else {
        _class += 'xxxxx';
      }
      return _class;
    },
    hideSubHeader: true,
    sort: false,
    columns: {
      placeCode: {
        title: 'POD'
      },
      address: {
        title: 'Adresa'
      },
      number: {
        title: 'Numar'
      },
      startingDate: {
        title: 'Data contract',
        valuePrepareFunction: (value) => value ? new Date(value).toLocaleDateString('ro-RO') : ''
      },
      operator: {
        title: 'Operator loc consum'
      },
      supplierName: {
        title: 'Furnizor'
      },
      contractType: {
        title: 'Tip contract'
      },
      expirationDate: {
        title: 'Valabil pana la',
        valuePrepareFunction: (value) => value ? new Date(value).toLocaleDateString('ro-RO') : ''
      },
      status: {
        title: 'Status'
      }
    },
  };

  public consumptionPlaceSettings = {
    actions: {
      custom: [
        {
          name: 'consumptionPlaceDetails',
          title: '<p>Detalii</p>'
        },
        {
          name: 'newContract',
          title: '<p class="actionCN">Adauga contract nou</p>'
        },
        {
          name: 'viewExistingContracts',
          title: '<p>Vizualizeaza contracte existente</p>'
        },
        {
          name: 'disassociateConsumptionPlace',
          title: '<p>Dezasociaza loc de consum</p>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    rowClassFunction: (row) => {
      let _class = '';
      if (row.data.status === 'DEZAFECTAT') {
        _class += 'row_dezafectat ';
      } else {
        _class += 'row_standard ';
      }
      return _class;
    },
    hideSubHeader: true,
    sort: false,
    columns: {
      code: {
        title: 'POD'
      },
      address: {
        title: 'Adresa'
      },
      status: {
        title: 'Status'
      }
    },
  };

  public requestSettings = {
    actions: {
      custom: [
        {
          name: 'view',
          title: '<p class="actionVD">Vezi detalii</p>'
        },
        {
          name: 'cancel',
          title: '<p class="actionA">Anuleaza</p>'
        },
        {
          name: 'complete',
          title: '<p class="actionR">Recompleteaza</p>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    rowClassFunction: (row) => {
      let _class = '';
      if (!row.data.wizard) {
        _class += 'row_no_wizard ';
      }
      if (row.data.status === 'Informatii suplimentare') {
        _class += 'row_more_info ';
      } else if (row.data.status === 'Anulata' || row.data.status === 'Finalizata') {
        _class += 'row_finished ';
      } else {
        _class += 'row_standard ';
      }
      return _class;
    },
    hideSubHeader: true,
    sort: false,
    columns: {
      id: {
        title: 'Numar cerere'
      },
      placeCode: {
        title: 'POD'
      },
      address: {
        title: 'Adresa'
      },
      contractNumber: {
        title: 'Numar contract'
      },
      startingDate: {
        title: 'Data contract',
        valuePrepareFunction: (value) => value ? new Date(value).toLocaleDateString('ro-RO') : ''
      },
      operator: {
        title: 'Operator loc consum'
      },
      supplier: {
        title: 'Furnizor'
      },
      date: {
        title: 'Data transmitere',
        valuePrepareFunction: (value) => value ? new Date(value).toLocaleDateString('ro-RO') : ''
      },
      status: {
        title: 'Status'
      }
    },
  };

  successAssociationNotification(): void {
    Swal.fire({
      title: ' ',
      text: 'Locul de consum ' + this.podValue + ' a fost asociat cu succes',
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    });
  }

  successDisassociationNotification(): void {
    Swal.fire({
      title: ' ',
      text: 'Locul de consum ' + this.podValue + ' a fost dezasociat cu succes',
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    });
  }

  errorNotification(message: string): void {
    Swal.fire({
      title: ' ',
      text: message,
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    });
  }

  errorNotificationHtml(message: string): void {
    Swal.fire({
      title: ' ',
      html: message,
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    });
  }

  openCancelModal(): void {
    const modalHtml = this.getTemplateAsString();
    const swalInstance = Swal.fire({
      html: modalHtml,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false
    });
  }

  getTemplateAsString(): string {
    const componentRef = this.container.createComponent(ModalContractCancelComponent);
    const template = componentRef.location.nativeElement.innerHTML;
    // console.log(template); // Output the template as a string
    componentRef.destroy(); // Destroy the dynamically created component
    return template;
  }

}
